const wordpressSiteUrl =
  process.env.REACT_APP_WORDPRESS_SITE_URL ||
  "http://localhost/onuratabaycom/server";

export const env = {
  appEnv: process.env.NODE_ENV || "development",
  cmsMode: process.env.REACT_APP_CMS_MODE || "hybrid",
  wordpressSiteUrl,
  wordpressApiBaseUrl:
    process.env.REACT_APP_WORDPRESS_API_BASE_URL ||
    `${wordpressSiteUrl}/wp-json/wp/v2`,
  wordpressApiFallbackUrl:
    process.env.REACT_APP_WORDPRESS_API_FALLBACK_URL ||
    `${wordpressSiteUrl}/index.php?rest_route=/wp/v2`,
  requestTimeoutMs: Number(process.env.REACT_APP_API_TIMEOUT_MS || 12000),
};
